import * as obraz from './obraz/api';

export const apiService = {
  obraz,
};
